import { UserFocus, Scales, FolderOpen, AirplaneTakeoff, ChatsCircle, Heartbeat } from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "../Reveal";

const PAINS = [
    { icon: UserFocus, title: "Finding the right specialist", text: "Understanding which specialist or hospital may be appropriate." },
    { icon: Scales, title: "Comparing options", text: "Making sense of hospitals, doctors, treatments and costs." },
    { icon: FolderOpen, title: "Managing medical records", text: "Sharing reports, scans, prescriptions and medical history across organizations." },
    { icon: AirplaneTakeoff, title: "Coordinating travel", text: "Managing visas, accommodation, transportation and hospital appointments." },
    { icon: ChatsCircle, title: "Navigating treatment", text: "Coordinating communication between patients, families, doctors and hospitals." },
    { icon: Heartbeat, title: "Continuing care", text: "Managing follow-up after returning home." },
];

export default function Problem() {
    return (
        <section id="why-gomedvoyage" data-testid="problem-section" className="py-28 lg:py-36 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <SectionHeading
                    chapter="01"
                    eyebrow="The Problem"
                    title="Healthcare across borders is still fragmented."
                    description="For an international patient, finding the right treatment can mean navigating a maze of disconnected steps."
                    testid="problem-heading"
                />
                <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {PAINS.map((p, i) => (
                        <Reveal key={p.title} delay={0.08 * i}>
                            <div
                                data-testid={`problem-card-${i + 1}`}
                                className="group h-full bg-white rounded-3xl border border-slate-100 p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] transition-[transform,box-shadow] duration-300"
                            >
                                <div className="w-12 h-12 rounded-2xl bg-tint-blue flex items-center justify-center text-brand-blue group-hover:bg-tint-green group-hover:text-brand-green transition-colors duration-300">
                                    <p.icon size={24} weight="duotone" />
                                </div>
                                <h3 className="mt-6 font-heading text-lg font-semibold text-brand-blue">{p.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-slate-600">{p.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.2}>
                    <p data-testid="problem-closing" className="mt-16 max-w-3xl font-heading text-2xl sm:text-3xl font-medium leading-snug text-brand-blue">
                        GoMedVoyage is being built to bring this fragmented journey together into{" "}
                        <span className="text-brand-green">one intelligent, patient-centric experience.</span>
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
